// extracted by mini-css-extract-plugin
export default {"Box":"collaborator-role-drop-down-module__Box--X8Mxf"};